import { createContext } from '@gluestack-ui/utils';
export const [PopoverProvider, usePopover] = createContext('PopoverContext');
export const [PopoverContentProvider, usePopoverContent] = createContext('PopoverContext');
